<div class="no-clinic-access-page">
  <div class="no-clinic-access-card">
    <div class="no-clinic-access-icon" aria-hidden="true">
      <i class="fa-solid fa-circle-exclamation"></i>
    </div>
    <h1>Oops</h1>
    <p class="lead">Clinic access is not available.</p>
    <p class="hint">
      Contact your organization administrator for support.
    </p>
    <div class="actions">
      <button
        type="button"
        class="btn btn-primary"
        [disabled]="signingOut"
        (click)="signOut()"
      >
        {{ signingOut ? "Signing out…" : "Sign out" }}
      </button>
    </div>
  </div>
</div>
